/**
 * Permiso de compañía para la personalización de correos (S2-126b).
 *
 * OJO: son DOS interruptores distintos y no se deben confundir.
 *
 *   company/{idc}.emailBrandingEnabled  -> PERMISO que concede SHOFI (SA) desde
 *     la ficha de compañía. Decide si la compañía tiene DERECHO a la
 *     funcionalidad. Es el que resuelve este helper.
 *   company/{idc}.emailBranding.enabled -> PREFERENCIA del AA dentro de su
 *     propia pantalla ("usa mi marca en vez de la de SHOFI").
 *
 * Contrato del default (decisión de producto, INVERTIDO el 2026-09-16 porque la
 * funcionalidad pasa a comercializarse): AUSENTE | undefined | null =
 * DESHABILITADO. Sólo el booleano `true` (o el string "true") concede. La
 * funcionalidad nace apagada para todas las compañías y SHOFI la enciende una
 * por una cuando se contrata.
 *
 * ESTE HELPER NO ES LA AUTORIDAD. Sólo sirve para ocultar la entrada de menú y
 * para no montar la ruta si alguien entra por URL directa. El enforcement real
 * vive en el backend:
 *   - 403 en `PUT /companyProfileV2/company/email-branding`.
 *   - `allowed:false` en `GET /companyProfileV2/company/email-branding`.
 *   - `getBranding` ignora el branding de una compañía sin permiso al enviar.
 * Espejo del mismo contrato: `functions/services/emailBranding.js`
 * (`isEmailBrandingAllowed`). Si cambia uno, cambia el otro.
 *
 * De dónde sale el dato: `AuthContext` hace spread del doc `company/{idc}`
 * dentro del perfil del user, así que `user.emailBrandingEnabled` ya está
 * disponible sin ninguna petición extra.
 *
 * @param {object} companyLike Objeto con el campo (el `user` del AuthContext,
 *   o la respuesta de `/companiesV2/detail/:id`).
 * @returns {boolean} true SOLO si el flag está explícitamente encendido.
 */
export const isEmailBrandingAllowed = (companyLike) => {
  if (!companyLike || typeof companyLike !== 'object') return false;
  const flag = companyLike.emailBrandingEnabled;
  return flag === true || flag === 'true';
};

export default isEmailBrandingAllowed;
